<template>
  <div class="m-4 p-4">
    <div class="container-full">
      <div class="row">
        <div class="col-lg-8">
          <div class="card">

            <template v-if="sessionId === null">
              <div class="m-4">
                <h1>No active session scheduled for<br />{{now_updated_every_min|shortDateTime}}</h1>
                <p>
                  Select one of the following...<br />
                  TODO: list of upcoming sessions<br />
                  - or - <br />
                  <el-button @click="onCreateInstantSession">Create a new session</el-button>
                </p>
              </div>
            </template>
            <template v-else>
              <!-- ------------- Vue Component: Session Timer ------------- -->
              <el-card class="m-4">
                <el-button-group>
                  <el-button @click="onPauseOrContinueSession">
                    <template v-if="isPaused">
                      <font-awesome-icon icon="play" /> Continue Session
                    </template>
                    <template v-else-if="notStarted">
                      <font-awesome-icon icon="play" /> Start Session
                    </template>
                    <template v-else>
                      <font-awesome-icon icon="pause" /> Pause Session
                    </template>
                  </el-button>
                  <el-button @click="onSessionDone">
                    <font-awesome-icon icon="stop" />
                    Finish Session and Save Points in Daytracker
                  </el-button>
                </el-button-group>
              </el-card>
              <!-- ------------- / Vue Component: Session Timer ------------- -->
              <template v-if="currently_active_session !== null">
                <template v-if="hasGoalAssigned">
                  <el-card class="m-4">
                    <template v-if="ready">
                      <SessionTaskList :session-id="sessionId" />
                    </template>
                  </el-card>
                </template>
                <template v-else>
                  <el-card class="m-4">
                    <h1>{{session.cachedName}}</h1>
                    <h3>Start: {{session.userStart|shortDateTime}}</h3>
                    <h3>End: {{session.userEnd|shortDateTime}}</h3>
                    <pre>Timekeeper: {{session.timekeeper}}</pre>
                    <el-button @click="onSessionDone()">Session Complete</el-button>
                    <!-- ^ DOPPELT -->
                  </el-card>
                  <el-card class="m-4">
                    <h3>No Goal Assigned!</h3>

                    <p>Wenn du in dieser session eine checkliste willst,
                    dann ordner diese session einem goal zu.. hier ist ein dropdown:</p>

                    <el-select v-model="selectedGoalId" placeholder="Select">
                      <el-option
                        v-for="goal in goalList"
                        :key="goal.id"
                        :value="goal.id"
                        :label="goal.cachedName">
                        <span :style="{
                          fontSize:   (goal.graphicalRepresentation.headline.fontSize/2) + 'pt',
                          fontFamily: goal.graphicalRepresentation.headline.fontFamily,
                          }">
                          {{goal.cachedName}}
                        </span>
                      </el-option>
                    </el-select>
                    <br>
                    <br>

                    <InlineGoal v-if="selectedGoalId" :goal_id="selectedGoalId" />
                    <el-button @click="onAddGoal()" type="secondary" size="small">Add goal</el-button>
                    <el-button @click="onConfirmGoal()" type="primary" size="small">Confirm goal</el-button>
                  </el-card>
                </template>
              </template>
              <template v-else>
                <el-card class="m-4">
                  <h1>{{session.cachedName}}</h1>
                  Start session...
                </el-card>
              </template>
            </template>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card">
            <div class="card-header">
              Today's sessions:
            </div>
            <div class="p-4">
              <el-button-group class="pb-4">
                <el-button @click="onSkipSession(-1)" size="mini">
                  <font-awesome-icon icon="fast-backward" />
                  Go to previous session
                </el-button>
                <el-button @click="onSkipSession(+1)" size="mini">
                  <font-awesome-icon icon="fast-forward" />
                  Skip session
                </el-button>
              </el-button-group>
              <!-- TODO: Show past sessions differntly -->
              <!-- TODO: Show if session was started but not finished (continue button) -->
              <div
                class="session-list-item"
                v-for="sess in todays_sessions"
                :key="sess.id"
                :style="{
                  opacity: sess._additional_is_past ? 0.66 : 1.0,
                  border: ( sess.id === currently_active_session ? '5px solid red' : (
                              sess.id === ( currently_planned_session || {}).id ? '5px solid blue' : ''
                          ) )
                }">
                <h5>{{sess.cachedName}}</h5>
                <div>Start: {{sess.userStart|shortDateTime}}</div>
                <div>End: {{sess.userEnd|shortDateTime}}</div>
                <div>Starts in:
                  {{Math.round(-sess._additional_starts_in / 1000 / 60)}} min<br />
                  Render dep check: {{Math.random()}}
                </div>
                <div>{{sess.done ? 'Finished' : 'NOT Finished'}}</div>
                <el-button plain type="success" @click="onStartSessionWithId( sess.id )" size="small" class="m-2">
                  <font-awesome-icon icon="play" />
                  Start now
                </el-button>
              </div>
            </div>
            <!-- <pre>{{todays_sessions}}</pre> -->
          </div>
          <ClockListener />
        </div>
      </div>
    </div>
    <pre v-if="SHOW_DEBUG">currently_planned_session: {{currently_planned_session}}</pre>
    <!--
    Ready: {{ready}}
    <h2>SessionTaskList: {{sessionId}}</h2>
    -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SessionTaskList from '@/components/SessionPage/SessionTaskList'
import InlineGoal from '@/components/Inline/InlineGoal'
import ClockListener from '@/components/SessionPage/ClockListener'
import moment from '@/moment-gp'

/*
TODO: SHow modal, when session over

TODO: Show previous and next sesion
TODO: Detect current sessions
TODO: Detect if current session is assigned for current timeout
TODO: Allow to jump between sessions
TODO: Show sidebar with todays events as "navigation"
*/

export default {
  name: 'SessionPage',
  data: () => ({
    sessionId: null,
    selectedGoalId: null,
  }),
  created() {
    this.setCurrentSession();
    /* TODO: Move to App.vue + Pause timer, when window is not active*/
    // this.session_start_system_timer();
  },
  mounted() {
    this.checkForActiveSessionAndRedirect();
  },
  beforeDestroy() {
    /* TODO: Move to App.vue */
    this.session_stop_system_timer();
  },
  watch: {
    $route (to, from) {
      /* check for route change if using <keep-alive>...</keep-alive> */
      if ( to.name === 'session' ) {
        this.setCurrentSession();
        this.checkForActiveSessionAndRedirect();
      }
    },
    /* timer minutes */
    time_updated_every_sec(time) {
      // console.log("tik", time);
    },
    now_updated_every_min(time) {
      // TODO: This gets subscribed with every save in dev view
      // console.log("tok", time);
      if ( this.$route.name === 'session' ) {
        this.checkForActiveSessionAndRedirect();
      }
    },
  },
  computed: {
    // ...mapGetters("goal",[
    //   "goal_list_meta_ready_without_deleted",
    //   // "goal_is_ready",
    //   // "goal_list_ids"
    // ]),
    ...mapGetters("calendar",[
      "currently_planned_session",
      "todays_sessions",
      "event_by_id"
    ]),
    ...mapGetters("session",[
      "time_updated_every_sec",
      "now_updated_every_min",
      "currently_active_session",
      "remaining_time_in_session",
      "is_session_overdrawn",
      "session_points",
      "todays_points",
      "currently_active_session_is_paused"
    ]),

    session() {
      return this.sessionId ? this.event_by_id( this.sessionId ) : {};
    },

    hasGoalAssigned() {
      return this.session && this.session.goalId;
    },

    ready() {
      let session = this.session;
      if ( session && this.hasGoalAssigned ) {
        return this.$api.get_ready( 'goal', session.goalId )
        // return this.goal_is_ready( session.goalId );
      } else {
        // return goal_list_ids && goal_list_ids.length > 0;
        return false;
      }
    },

    goalList() {
      return this.$models.goalMeta.getters.all_goals;
    },

    isPaused() {
      return this.currently_active_session_is_paused;
    },

    notStarted() {
      return this.currently_active_session === null;
    }
  },
  methods: {
    ...mapActions("calendar",[
      "calendar_update_event",
      "calendar_create_event"
    ]),
    ...mapActions("session",[
      "session_start_system_timer",
      "session_stop_system_timer",
      "session_skip_to_next",
      "session_start",
      "session_pause",
      "session_continue",
      "session_restart",
      "session_stop",
    ]),

    checkForActiveSessionAndRedirect() {

      if ( this.$route.params.sessionId ) {
        /* We're at /session/<sessionId> */
        // 1. Check if session is over
        // 2. Check if next session has begun
        // 3. Check if sessionId matches currently active sessions
        //    (user selected session in the calendar and said 'start work')

      } else {
        /* We're at /session/ */
        // This means we're waiting for something to happen
        // 1. Check if there is an active session

        console.log("checkForActiveSessionAndRedirect");
        let currentlyPlannedSession = this.currently_planned_session;
        /* TODO: if there is an active session, redirect to /session/sessionId */
        console.log("currentlyPlannedSession", currentlyPlannedSession);
        if ( currentlyPlannedSession ) {
          console.log("..redirect");
          this.$router.push('/session/' + currentlyPlannedSession.id)
        }
      }
    },

    setCurrentSession() {
      this.sessionId = this.$route.params.sessionId || null;
    },

    onAddGoal() {
      this.$root.showNewModal('goal');
    },

    onConfirmGoal() {
      console.log("onConfirmGoal", this.sessionId, this.selectedGoalId);
      this.calendar_update_event({
        eventId: this.sessionId,
        eventData: {
          goalId: this.selectedGoalId
        }
      });
    },

    onSessionDone() {
      console.log("onSessionDone");

      this.session_stop({
        sessionId: this.sessionId,
        goalId: this.session.goalId /* null if not goal assigned */
      });
    },

    onSkipSession(dir) {
      console.log("onSkipSession", dir);
      if ( dir === -1 ) {
        this.session_restart({
          sessionId: this.sessionId
        });
      } else {
        this.session_skip_to_next();
      }
    },

    onPauseOrContinueSession() {
      if ( this.isPaused ) {
        this.session_continue({
          sessionId: this.sessionId,
          goalId: this.session.goalId /* null if not goal assigned */
        });
      } else {
        if ( this.notStarted ) {
          /* If no active sesssion this means it's a start */
          this.session_start({
            sessionId: this.sessionId,
            goalId: this.session.goalId /* null if not goal assigned */
          });
        } else {
          this.session_pause({
            sessionId: this.sessionId,
            goalId: this.session.goalId /* null if not goal assigned */
          });
        }
      }
    },

    onStartSessionWithId(id) {
      console.log("onStartSessionWithId", id);
      this.session_start({
        sessionId: id,
        goalId: this.session.goalId /* null if not goal assigned */
      });
    },

    onCreateInstantSession() {
      let sessionMinutes = parseInt( prompt('How many minutes?') );
      this.calendar_create_event({
        name:  'Instant session',
        payload: {
          start:        moment.currentTime(),
          end:          moment.currentTime().add(sessionMinutes, 'minutes'),
          originIsOptimizer: false
        }
      }).then(sessionId => {
        this.$router.push('/session/' + sessionId)
        // this.checkForActiveSessionAndRedirect();
      });
    }
  },
  components: {
    SessionTaskList,
    ClockListener,
    InlineGoal
  }
}
</script>

<style>
.session-list-item {
  border: 1px solid #c0c4cc;
  margin-bottom: 1em;
  padding: 0.5em;
  box-shadow: 0 2px 10px -2px #00000042;
}
</style>
